import {Shared} from '@/app/shared/model/shared.model';

export namespace AccountOption {
  export const EMAIL: Shared.Options[] = [
    new Shared.Options('선택', null, true),
    new Shared.Options('직접입력', ''),
    new Shared.Options('naver.com', 'naver.com'),
    new Shared.Options('gmail.com', 'gmail.com'),
    new Shared.Options('kakao.com', 'kakao.com'),
    new Shared.Options('daum.net', 'daum.net'),
    new Shared.Options('hanmail.net', 'hanmail.net'),
    new Shared.Options('nate.com', 'nate.com'),
    new Shared.Options('hotmail.com', 'hotmail.com')
  ];
}